import React from "react";
import { Modal, Show, Typography, Button, Alert } from "@pankod/refine-antd";
import { useNavigation } from "@pankod/refine-core";
import { statusOptions } from "../../constants/workPlan.constants";
import { impactAxisIcons } from "../../constants/impactAxisIcons";

const { Title, Text } = Typography;

interface WorkPlanDetailModalProps {
  visible: boolean;
  onCancel: () => void;
  onOk: () => void;
  isLoading: boolean;
  showId: string | number;
  showRecord: any;
  hasEditPermission?: boolean;
}

export const WorkPlanDetailModal: React.FC<WorkPlanDetailModalProps> = ({
  visible,
  onCancel,
  onOk,
  isLoading,
  showId,
  showRecord,
  hasEditPermission = true
}) => {
  const { push } = useNavigation();

  return (
    <Modal 
      visible={visible} 
      onCancel={onCancel} 
      onOk={onOk} 
      width={800}
      footer={null}
    >
      <Show
        isLoading={isLoading}
        recordItemId={showId}
        resource="work-plans"
        headerProps={{
          title: "Plan de Trabajo",
        }}
        headerButtons={() => (
          <>
            {hasEditPermission && (
              <Button
                type="primary"
                onClick={() => push(`/work-plans/edit/${showRecord?.id}`)}
              >
                Editar
              </Button>
            )}
          </>
        )}
      >

        { showRecord?.observation && (
          <Alert
            message="Observación"
            description={`${showRecord.observation}`}
            type="warning"
            showIcon
            style={{ marginBottom: 24 }}
          />
        )}
        <Title level={5}>ID</Title>
        <Text>{showRecord?.id}</Text>
        
        <Title level={5}>Eje de Impacto</Title>
        <Text>
          <span style={{ marginRight: '8px', fontSize: '16px' }}>
            {impactAxisIcons[showRecord?.impact_axis || ""] || "📋"}
          </span>
          {showRecord?.impact_axis || "--"}
        </Text>
        
        <Title level={5}>Fechas</Title>
        <Text>
          Del <strong>{showRecord?.start_date}</strong>
          {showRecord?.start_time && (
            <> a las <strong>{showRecord.start_time}</strong></>
          )}
          {showRecord?.end_date && (
            <> al <strong>{showRecord.end_date}</strong>
            {showRecord?.end_time && (
              <> a las <strong>{showRecord.end_time}</strong></>
            )}
            </>
          )}
        </Text>
        
        <Title level={5}>Unidad Organizacional</Title>
        <Text>{showRecord?.work_plan_position?.name || "--"}</Text>

        <Title level={5}>Objetivo General</Title>
        <Text>{showRecord?.general_objective || "--"}</Text>
        
        <Title level={5}>Meta</Title>
        <Text>{showRecord?.goal || "--"}</Text>
        
        <Title level={5}>Estrategia</Title>
        <Text>{showRecord?.strategy || "--"}</Text>
        
        <Title level={5}>Público Objetivo</Title>
        <Text>{showRecord?.audience || "--"}</Text>
        
        <Title level={5}>Alcance</Title>
        <Text>{showRecord?.scope || "--"}</Text>
        
        <Title level={5}>Apoyo Vicerrectoría</Title>
        <Text>
          {showRecord?.support_budget 
            ? `$${showRecord.support_budget.toLocaleString()}` 
            : "--"}
        </Text>

        <Title level={5}>Presupuesto Total</Title>
        <Text>
          {showRecord?.total_budget 
            ? `$${showRecord.total_budget.toLocaleString()}` 
            : "--"}
        </Text>
        {showRecord?.budget_url && (
          <div style={{ margin: '8px 0' }}>
            <a href={showRecord.budget_url} target="_blank" rel="noopener noreferrer">
              Descargar presupuesto (PDF)
            </a>
          </div>
        )}

        {showRecord?.evidence_url && (
          <>
            <Title level={5}>Evidencia</Title>
            <div style={{ margin: '8px 0' }}>
              <a href={showRecord.evidence_url} target="_blank" rel="noopener noreferrer">
                Descargar evidencia (PDF)
              </a>
            </div>
          </>
        )}
        
        <Title level={5}>Estatus</Title>
        <Text>
          {statusOptions[showRecord?.status as keyof typeof statusOptions] || showRecord?.status || "--"}
        </Text>
      </Show>
    </Modal>
  );
};
